import React, { useState, useEffect } from "react";
import styles from "./expert-spotlight.module.css";

// Placeholder content
const FEATURED_EXPERTS = [
  {
    id: 1,
    name: "Dr. Lisa Mosconi",
    role: "Neuroscientist",
    title: "Director, Alzheimer’s Prevention Program at Weill Cornell",
    location: "New York, NY",
    quote: "Standard medical advice ignores the unique biological reality of the female brain.",
    bio: "Dr. Lisa Mosconi is the Director of the Alzheimer’s Prevention Program at Weill Cornell Medicine and the author of The XX Brain. She specializes in the early detection of Alzheimer’s disease in women and how to prevent it.",
    chapters: ["Chapter 3: The Female Brain", "Chapter 7: Long-term Prevention"],
    image: "/assets/dr-pics/dr_lisa_mosconi.PNG"
  },
  {
    id: 2,
    name: "Dr. Aviva Romm",
    role: "Integrative Physician",
    title: "Midwife & Herbalist",
    location: "Stockbridge, MA",
    quote: "We need a new model of women's health that listens to women's bodies instead of dismissing them.",
    bio: "Dr. Aviva Romm is a Yale-trained physician specializing in integrative medicine for women and children. She bridges the gap between traditional medicine and herbalism.",
    chapters: ["Chapter 1: Hormonal Balance", "Chapter 5: Thyroid Health"],
    image: "/assets/dr-pics/dr_aviv_romm.PNG"
  },
  {
    id: 3,
    name: "Dr. Stacy Sims",
    role: "Exercise Physiologist",
    title: "Nutrition Scientist",
    location: "Mount Maunganui, NZ",
    quote: "Women are not small men. Our training and nutrition must reflect our physiology.",
    bio: "Dr. Stacy Sims is an applied researcher, innovator, and entrepreneur in human performance, specifically sex differences in training, nutrition, and environmental conditions.",
    chapters: ["Chapter 9: Training for Women", "Chapter 10: Fueling Performance"],
    image: "/assets/dr-pics/dr_stacy_sims.PNG"
  }
];

export default function ExpertSpotlight() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % FEATURED_EXPERTS.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isPaused]);

  return (
    <section className={styles.section}>
      <div className={styles.carouselContainer}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}>
        {FEATURED_EXPERTS.map((expert, index) => {
          let slideClass = styles.slide;
          if (index === currentIndex) {
            slideClass = `${styles.slide} ${styles.activeSlide}`;
          }

          return (
            <div key={expert.id} className={slideClass}>
              <div className={styles.spotlightRow}>

                {/* Left Column: Expert Profile */}
                <div className={styles.leftColumn}>
                  <div className={styles.expertProfile}>
                    <div className={styles.profileHeader}>
                      <div className={styles.profileImageWrap}>
                        <img src={expert.image} alt={expert.name} className={styles.profileImage} />
                      </div>
                      <div className={styles.profileMeta}>
                        <h3 className={styles.profileName}>{expert.name}</h3>
                        <div className={styles.profileRole}>{expert.role}</div>
                        <div className={styles.profileTitle}>{expert.title}</div>
                        <div className={styles.profileLocation}>{expert.location}</div>
                      </div>
                    </div>
                    <div className={styles.profileSeparator}></div>
                    <div className={styles.profileSocials}>
                      <a href="#" className={styles.profileSocialLink} aria-label="Instagram">
                        <img src="/assets/logos/instagram.svg" alt="Instagram" className={styles.profileSocialIcon} />
                      </a>
                      <a href="#" className={styles.profileSocialLink} aria-label="YouTube">
                        <img src="/assets/logos/youtube.svg" alt="YouTube" className={styles.profileSocialIcon} />
                      </a>
                      <a href="#" className={styles.profileSocialLink} aria-label="Apple Podcasts">
                        <img src="/assets/logos/applepodcasts.svg" alt="Apple Podcasts" className={styles.profileSocialIcon} />
                      </a>
                      <a href="#" className={styles.profileSocialLink} aria-label="Substack">
                        <img src="/assets/logos/substack.svg" alt="Substack" className={styles.profileSocialIcon} />
                      </a>
                      <a href="#" className={styles.profileSocialLink} aria-label="Website">
                        <span className="material-icons" style={{ fontSize: "20px" }}>language</span>
                      </a>
                    </div>
                  </div>
                </div>

                {/* Right Column: Info Panel */}
                <div className={styles.rightColumn}>
                  <div className={styles.infoPanel}>
                    <div className={styles.bioSection}>
                      <p className={styles.bioText}>{expert.bio}</p>
                    </div>

                    <div className={styles.chaptersSection}>
                      <span className={styles.sectionLabel}>Referenced In:</span>
                      <ul className={styles.chapterList}>
                        {expert.chapters.map((chap, i) => (
                          <li key={i}>{chap}</li>
                        ))}
                      </ul>
                    </div>

                    <div className={styles.quoteSection}>
                      <blockquote className={styles.panelQuote}>"{expert.quote}"</blockquote>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.navigation}>
        {FEATURED_EXPERTS.map((_, index) => (
          <button
            key={index}
            className={`${styles.dot} ${index === currentIndex ? styles.activeDot : ""}`}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
